
export const statusCodes = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
}

// Constant Strings
export const responseStrings = {
    INVALID_USER: 'INVALID_USER',
    INVALID_PASSWORD: 'INVALID_PASSWORD',
    SERVER_ERROR: 'SERVER_ERROR',
    UNAUTHORIZED_ACCESS: 'UNAUTHORIZED_ACCESS',
    USER_CREATED : "USER_CREATED",
    LOGIN_SUCCESS : "LOGIN_SUCCESS",
    DATA_UPDATED_SUCCESSFULLY : "DATA_UPDATED_SUCCESSFULLY",
    DELETED_SUCCESSFULLY : "DELETED_SUCCESSFULLY",
    DATABASE_ERROR : "DATABASE_ERROR",
    PASSWORD_CHANGED : "PASSWORD_CHANGED",
    RESOURCE_NOT_FOUND : "RESOURCE_NOT_FOUND",
    INVALID_EMAIL : "INVALID_EMAIL",
    INVALID_PHONE_NUMBER : "INVALID_PHONE_NUMBER",
    LOGOUT_SUCCESS : "LOGOUT_SUCCESS",
    PASSWORD_RESET_EMAIL_SENT : "PASSWORD_RESET_EMAIL_SENT",
    PROFILE_UPDATED : "PROFILE_UPDATED",
    EMAIL_ALREADY_EXISTS : "EMAIL_ALREADY_EXISTS",
    ACCESS_DENIED : "ACCESS_DENIED",
    EXISTING_USER : "EXISTING_USER",
    NO_DATA_AVAILABLE : "NO_DATA_AVAILABLE",
    PROFILE_INCOMPLETE : "PROFILE_INCOMPLETE",
    INVALID_TOKEN : "INVALID_TOKEN",
    TOKEN_REQUIRED : "TOKEN_REQUIRED",
    EXISTING_NUMBER : "EXISTING_NUMBER",
    EXISTING_EMAIL : "EXISTING_EMAIL",   
}

export const screenTypes = {
    MOBILE : "MOBILE",
    TABLET : "TABLET",
    LAPTOP : "LAPTOP",
    NONE : "NONE"
}